import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { UpdateBannerData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
import { fileUrl } from "../../Config/Config";

export default function EditBanner() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const [inputs, setInputs] = useState({
    screen: "",
    link: "",
    isInternalLink: "",
    country: "",
    file: "",
    startTime: null,
    endTime: null,
  });
  const [previewImage, setPreviewImage] = useState("");

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = (e) => {
    const name = e.target.name;
    const value = e.target.files[0];
    setPreviewImage(URL.createObjectURL(value));
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("link", inputs?.link);
    formData.append("screen", inputs?.screen);
    formData.append("isInternalLink", inputs?.isInternalLink);
    formData.append("country", inputs?.country);
    formData.append("file", inputs?.file);
    formData.append(
      "startTime",
      moment(inputs.startTime).format("YYYY-MM-DD HH:mm:ss.SSSZ")
    );
    formData.append(
      "endTime",
      moment(inputs.endTime).format("YYYY-MM-DD HH:mm:ss.SSSZ")
    );
    const resp = await UpdateBannerData(id, formData);
    if (resp?.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate(-1);
    } else {
      enqueueSnackbar(resp?.error, { variant: "error" });
    }
  };

  useEffect(() => {
    if (state) {
      setInputs({
        screen: state?.screen,
        link: state?.link,
        isInternalLink: state?.isInternalLink,
        country: state?.country,
        file: state?.file,
        startTime: state?.startTime ? new Date(state.startTime) : null,
        endTime: state?.endTime ? new Date(state.endTime) : null,
      });
    }
  }, [state]);
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography variant="h5">Edit Banner</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "10px" }}>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextField
              label="Link *"
              fullWidth
              name="link"
              size="small"
              value={inputs?.link}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">
                Internal Link
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputs?.isInternalLink}
                name="isInternalLink"
                label="Internal Link"
                onChange={handleChange}
              >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Screen Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputs?.screen}
                name="screen"
                label="Screen Type"
                onChange={handleChange}
              >
                <MenuItem value={"Wallet"}>Wallet</MenuItem>
                <MenuItem value={"Family"}>Family</MenuItem>
                <MenuItem value={"Ranking"}>Ranking</MenuItem>
                <MenuItem value={"WalletAdvertise"}>WalletAdvertise</MenuItem>
                <MenuItem value={"InLiveMini"}>InLiveMini</MenuItem>
                <MenuItem value={"LiveHomePage"}>LiveHomePage</MenuItem>
                <MenuItem value={"SplashFullScreen"}>SplashFullScreen</MenuItem>
                <MenuItem value={"Pk"}>Pk</MenuItem>
                <MenuItem value={"Party"}>Party</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextField
              label="Country *"
              fullWidth
              value={inputs?.country}
              name="country"
              size="small"
              onChange={handleChange}
            />
          </Grid>
          <Grid
            item
            lg={6}
            md={12}
            sm={12}
            xs={12}
            sx={{ display: "flex", gap: "10px" }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                label="Select Start Date & Time *"
                value={inputs?.startTime}
                fullWidth
                onChange={(newValue) =>
                  setInputs((prev) => ({ ...prev, ["startTime"]: newValue }))
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                label="Select End Date & Time *"
                value={inputs?.endTime || null}
                onChange={(newValue) =>
                  setInputs((prev) => ({ ...prev, ["endTime"]: newValue }))
                }
                renderInput={(params) => (
                  <TextField {...params} sx={{ width: "100%" }} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid
            item
            lg={12}
            mg={12}
            sm={12}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <div>
              <Typography>Upload Image</Typography>
              <FormHelperText>Supported Format (JPG,JPEG,PNG)</FormHelperText>
            </div>
            <div>
              {previewImage ? (
                <img
                  src={previewImage}
                  alt=""
                  style={{ width: "100px", height: "70px" }}
                />
              ):(
                <img
                  src={fileUrl + state?.image?.url}
                  alt=""
                  style={{ width: "100px", height: "100px",objectFit:"contain" }}
                />

              )}
            </div>
            <div>
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="upload-button"
                type="file"
                onChange={handleImageUpload}
                name="file"
              />
              <label htmlFor="upload-button">
                <Button
                  variant="contained"
                  component="span"
                  className="gradientButton"
                >
                  Upload
                </Button>
              </label>
            </div>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              className="gradientButton"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
